// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusDotIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || '#00A63E';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="status dot"
      className={className}
      style={style}
      {...rest}
    >
      <circle cx="8" cy="8" r="8" fill={fill} />
    </svg>
  );
};

export { StatusDotIcon };
